import { render, staticRenderFns } from "./copyrightWorkRegistration.vue?vue&type=template&id=261824aa&scoped=true&"
import script from "./copyrightWorkRegistration.vue?vue&type=script&lang=js&"
export * from "./copyrightWorkRegistration.vue?vue&type=script&lang=js&"
import style0 from "./copyrightWorkRegistration.vue?vue&type=style&index=0&id=261824aa&prod&lang=less&scoped=true&"
import style1 from "./copyrightWorkRegistration.vue?vue&type=style&index=1&id=261824aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261824aa",
  null
  
)

export default component.exports